import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import AdsterraAdvertise from "../Adsterra/AdsterraAdvertise";

const AnimeFanPage = () => {
  const [search, setSearch] = useState("");

  return (
    <div className="App bg-dark text-white d-flex flex-column min-vh-100">
      {/* HEADER */}
      <header>
        <nav className="navbar navbar-expand-lg navbar-dark bg-black shadow">
          <div className="container">
            <a className="navbar-brand fw-bold text-danger" href="#home">
              🌸 AnimeVerse
            </a>

            {/* Toggle for Mobile */}
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <a className="nav-link text-white" href="#home">Home</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link text-white" href="#characters">Characters</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link text-white" href="#gallery">Gallery</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link text-white" href="#contact">Contact</a>
                </li>
              </ul>

              {/* Search Bar */}
              <form className="d-flex ms-lg-3 mt-2 mt-lg-0">
                <input
                  className="form-control form-control-sm"
                  type="search"
                  placeholder="Search Anime..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </form>
            </div>
          </div>
        </nav>
      </header>

      {/* BODY CAROUSEL */}
      <section id="home" className="flex-grow-1">
        <div id="animeCarousel" className="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src="images/carousel/download-1-a.png" className="d-block w-100" alt="Anime Scene 1" style={{ height: "70vh", objectFit: "cover" }} />
              <div className="carousel-caption d-block d-md-block d-sm-block d-xxl-block">
                <h2 className="fw-bold text-light">Welcome to AnimeVerse</h2>
                <p>Dive into worlds of heroes, legends, and dreams 🌠</p>
              </div>
            </div>

            <div className="carousel-item">
              <img src="images/carousel/wp4240626-yami-sukehiro-wallpapers.png" className="d-block w-100" alt="Anime Scene 2" style={{ height: "70vh", objectFit: "cover" }} />
              <div className="carousel-caption d-block d-md-block d-sm-block d-xxl-block">
                <h2 className="fw-bold text-light">Epic Battles & Bonds</h2>
                <p>Celebrate the stories that shaped generations ⚔️</p>
              </div>
            </div>

            <div className="carousel-item">
              <img src="images/carousel/anime-crossover.png" className="d-block w-100" alt="Anime Scene 3" style={{ height: "70vh", objectFit: "cover" }} />
              <div className="carousel-caption d-block d-md-block d-sm-block d-xxl-block">
                <h2 className="fw-bold text-light">Your Favorite Characters</h2>
                <p>From Naruto to Luffy, relive the magic ✨</p>
              </div>
            </div>
          </div>

          <button className="carousel-control-prev" type="button" data-bs-target="#animeCarousel" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#animeCarousel" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </section>

      {/* CHARACTERS GRID */}
      <section id="characters" className="py-5 bg-black text-center">
        <div className="container">
          <h2 className="fw-bold text-danger mb-4">Top Anime Characters</h2>
          <div className="row">
            {[
              {name: "Naruto Uzumaki 🍜", img: "images/anime/naruto-drip-in-all-black-clothing-cvn22ug7blsp10on-2.png"},
              {name: "Monkey D. Luffy ☠️", img: "images/anime/luffy-phone-wallpaper-3b9rzo5c5lphgy3b.png"},
              {name: "Goku 🔥", img: "images/anime/goku-dragon-ball-8k-5k-3840x2160-17944.jpg"}
            ].map((c, i) => (
              <div className="col-md-4 mb-4" key={i}>
                <img src={c.img} alt={c.name} className="img-fluid rounded-4 shadow col-md-12" />
                <h5 className="mt-3">{c.name}</h5>
              </div>
            ))}
          </div>
        </div>
      </section>
      <div>
        <AdsterraAdvertise/>
      </div>

      {/* FOOTER */}
      <footer className="bg-black py-3 border-top border-danger text-center">
        <div className="container">
          <p className="mb-1 text-secondary">© {new Date().getFullYear()} AnimeVerse — Made with ❤️ for anime fans.</p>
          <a href="#privacy" className="text-decoration-none text-secondary mx-2">Privacy</a>|
          <a href="#terms" className="text-decoration-none text-secondary mx-2">Terms</a>
        </div>
      </footer>
    </div>
  );
};

export default AnimeFanPage;